/* global window */

function exists(namespace) {
  var tokens = namespace.split(".");
  return tokens.reduce(function (prev, curr) {
    return typeof prev == "undefined" ? prev : prev[curr];
  }, window);
}

export default exists;
